// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.teams-members__container {
    padding: var( --space-and-half );
}

.teams-members__container span.icon-search {
    position: absolute;
    font-size: calc( var(--space ) + var(--space-quarter ) );
    color: #949F9A;
    margin-left: calc( var(--space ) - var(--space-eighth ) );
}

.teams-members__search-bar{
    display: flex;
    align-items: center;
}

.teams-members__search_input {
    min-width: calc(var(--space-x3) * 8);
    border: 1px solid var(--new-gray-background-color);
    min-height: var(--space-x3 );
    border-radius: 4px;
    background: var(--new-background-color );
    padding-left: var(--space-x3 );
}

.teams-members__search-tags {
    display: flex;
    gap: 12px;
    margin: 12px 0;
}

.MuiChip-root.teams-members__search-tags__tag {
    color: var(--basic-gray-color);
    background-color: var(--white-color);
    border: 1px solid var(--basic-gray-color);
}

.MuiChip-root.teams-members__search-tags__tag:hover {
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}

.MuiChip-root.teams-members__search-tags__tag.selected {
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}

.teams-members__container .scroll {
    padding-right: calc( var( --space-x3 ) + var( --space ) );
    padding-left: calc( var( --space-x3 ) + var( --space ) );
    height: 300px;
}

.teams-members__container__card {
    width: 100%;
    border-radius: 2px;
    margin-bottom: var( --space );
    display: flex;
    align-items: center;
    justify-content: space-between; 
    cursor: pointer; 
}

.teams-members__container__card .baloa-names{
    color: var(--primary-very-dark-color);
}

.teams-members__container__card__info{
    margin-bottom: var(--space-quarter);
    display: flex;
    align-items: center;
}

.teams-members__container__card__info img {
    width: calc( var( --space-x2 ) + var( --space-half ) );
    height: calc( var( --space-x2 ) + var( --space-half ) );
    border-radius: 50%; 
}

.teams-members__container__card__info .icon-ball  {
    font-size: var( --space-x2 );
    color: var( --white-color );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.teams-members__container__card__info .icon-trophy {
    font-size: calc( var( --space-x2 ) - var( --space-eighth ) );
    color: var( --basic-gray-color );
}

.teams-members__container__card .icon-chevron-roght {
    color: var(--basic-green-color);
}

.teams-members__container__card__headers{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--new-background-color);
    border-radius: 8px 8px 0 0;
    padding: 11px 16px;
    margin-bottom: 12px;
}

.teams-members__container__card__headers .baloa-table-column{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.teams-members__subtitle.baloa-username {
    margin-top: var( --space-quarter );
}

.team-members__rute {
    display: flex;
    width: 392px;
    height: var(--space-x2);
    margin-top: var(--space-x2);
    margin-left: var(--space-half);
    border-radius: var(--space-half);
    background: var(--white-color);
}

.team-members__rute__img {
    color: var(--basic-green-color); 
    margin-left: var(--space-quarter);
    padding: var(--space-quarter) var(--space) var(--space-quarter) var(--space-quarter); 
}

.team-members__rute .icon-chevron-roght {
    color: var(--basic-green-color);
    margin: var(--space-quarter);
}

.team-members__rute__pague {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: calc(var(--space) - 4px);
    line-height: var(--space);
    display: flex;
    align-items: center;
    letter-spacing: 0.004em;
}

.team-members__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    
}

.team-members__team-photo {
    margin-top: var( --space-half-quarter );
}

.team-members__team-photo .icon-ball {
    font-size: calc( var( --space-x3 ) + var( --space-x2 ) + var( --space-quarter ) );
    padding: var( --space-half );    
    color: var(--white-color);
    border-radius: 50%;
    
}

.team-members__team-photo img{
    width: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) );
    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) );
    border-radius: 50%;
}

.icon-x.team-members__icon-back{
    color: var( --primary-dark-color );
    font-size: var(--space);
    cursor: pointer;
    margin-bottom: var( --space-half );   
}

.league-team-members .new-tournament__center__content__tabs {
    margin: 0;
}

.league-team-members {
    background-color: var( --white-color );
    border-radius: calc( var( --space ) - var( --space-eighth ) );
}

.team-members__header a {
    justify-content: flex-end;
    display: flex;
    width: 100%;
    margin: calc( var( --space ) + var( --space-quarter ) ) calc( var( --space ) + var( --space-eighth ) ) 0 0;
}

.team-members__header .baloa-headline-2 {
    color: var( --primary-dark-color );
    margin-top: var( --space );
    margin-bottom: var( --space-half );
}

.team-members__header .baloa-normal-medium:first-of-type {
    color: var( --basic-gray-color );    
}

.team-members__header .baloa-normal-medium:last-of-type {
    color: var( --primary-dark-color );
    margin: var( --space-half ) 0 var( --space-and-half ) 0;
}

.league-team-members__team-name {
    margin-left: var( --space-half );
}

.league-team-members__tournament-team {
    margin-left: var( --space );
}

.league-team-members__team-name .baloa-names,
.league-team-members__tournament-team .baloa-names {
    margin-bottom: var( --space-quarter );
}

.league-team-members__tournament-team .baloa-names,
.league-team-members__tournament-team .baloa-username {
    color: var( --primary-dark-color );
}

.league-team-members__team-name .baloa-names {
    display: flex;
    align-items: center;
    gap: 4px;
}

.league-team-members__btn-follow span {
    font-size: calc( var( --space ) - var( --space-eighth ));
}

.league-team-members__btn-follow.following {
    color: var( --white-color );
    background: var( --new-green-color ) ;
}

.teams-members_tournamentList_card {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: var(--space-x2);
}

.teams-members_tournamentList_card:hover{
    background-color:rgba(177, 177, 177, 0.25);
    cursor: pointer;
    border-radius:4px;
}

.teams-members_tournamentList_card .icon-ball {
    color: var( --white-color );
    font-size: var( --space-x2 );
    border-radius: 50%;
    padding: var( --space-quarter );  
}

.teams-members_tournamentList_img{
    width: var(--space-x2-and-half);
    height: var(--space-x2-and-half);
    float: left;
    margin-top: var(--space-quarter);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half);
    border-radius: 50%;
}

.teams-members_tournamentList_card .icon-ball {
    color: var( --white-color );
    font-size: var( --space-x2 );
    border-radius: 50%;
    padding: var( --space-quarter );  
}

.teams-members_tournamentList_card_inf{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
}

.teams-members_tournamentList_card_text{
    margin-left: var(--space-half);
}

.teams-members_tournamentList_card_text .baloa-names{
    color: var(--primary-dark-color);
    margin-bottom: var(--space-quarter);
}

.teams-members_tournamentList_card_subText{
    display: flex;
    align-items: baseline;
}

.teams-members_tournamentList_card_subText.baloa-username p{
    color: var(--primary-dark-color);
    margin-right: var(--space);
}

.teams-members_tournamentList_card_tags div {
    background: var( --primary-dark-color );
    color: var( --white-color );
    border-radius: var( --space-and-half );
    padding: var( --space-quarter ) var( --space-half );
}

.teams-members_tournamentList_card_tags.baloa-username{
    color: var( --primary-dark-color);
    font-size: 11px;
}

.teams-members_tournamentList_card_tags  {
    display: flex;
}

.teams-members_tournamentList_card_tags .tag-active{
    background: var(--new-green-color);
}

.teams-members_tournamentList_card_tags div:first-of-type {
    margin-right: var( --space-quarter );
}

.teams-members_tournamentList_card_tags div:last-of-type {
    margin-left: var( --space-quarter );
}

.league-team-members__team-name .baloa-username{
    color: var(--basic-gray-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .teams-members__container {
        padding: 12px;
    }

    .teams-members_tournamentList_card{
        margin: var(--space-half) 0;
    }

    .teams-members_tournamentList_card_inf {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .teams-members_tournamentList_card_text .baloa-names{
        font-size: var(--space);
    }

    .teams-members_tournamentList_card_subText.baloa-username p{
        font-size: var(--space);
    }

    .teams-members_tournamentList_card_tags.baloa-username {
        margin: var(--space) 0;
    }

    .teams-members__container .scroll{
        padding: 0;
        height: 56vh; /*TODO: limite largo*/
    }

    .teams-members_tournamentList_card_tags div{
        font-size: calc( var(--space) - var(--space-quarter) );
    }

}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-team-members/LeagueTeamMembersComponent.styles.css"],"names":[],"mappings":";AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,wDAAwD;IACxD,cAAc;IACd,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,4BAA4B;IAC5B,kBAAkB;IAClB,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,yDAAyD;IACzD,wDAAwD;IACxD,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sDAAsD;IACtD,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,4DAA4D;IAC5D,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uCAAuC;IACvC,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,oFAAoF;AACxF;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;AAEvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iFAAiF;IACjF,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,6EAA6E;IAC7E,8EAA8E;IAC9E,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,0GAA0G;AAC9G;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,uDAAuD;AAC3D;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,WAAW;IACX,gCAAgC;IAChC,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,sCAAsC;IACtC,mDAAmD;AACvD;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY,EAAE,qBAAqB;IACvC;;IAEA;QACI,sDAAsD;IAC1D;;AAEJ","sourcesContent":["\n.teams-members__container {\n    padding: var( --space-and-half );\n}\n\n.teams-members__container span.icon-search {\n    position: absolute;\n    font-size: calc( var(--space ) + var(--space-quarter ) );\n    color: #949F9A;\n    margin-left: calc( var(--space ) - var(--space-eighth ) );\n}\n\n.teams-members__search-bar{\n    display: flex;\n    align-items: center;\n}\n\n.teams-members__search_input {\n    min-width: calc(var(--space-x3) * 8);\n    border: 1px solid var(--new-gray-background-color);\n    min-height: var(--space-x3 );\n    border-radius: 4px;\n    background: var(--new-background-color );\n    padding-left: var(--space-x3 );\n}\n\n.teams-members__search-tags {\n    display: flex;\n    gap: 12px;\n    margin: 12px 0;\n}\n\n.MuiChip-root.teams-members__search-tags__tag {\n    color: var(--basic-gray-color);\n    background-color: var(--white-color);\n    border: 1px solid var(--basic-gray-color);\n}\n\n.MuiChip-root.teams-members__search-tags__tag:hover {\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}\n\n.MuiChip-root.teams-members__search-tags__tag.selected {\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}\n\n.teams-members__container .scroll {\n    padding-right: calc( var( --space-x3 ) + var( --space ) );\n    padding-left: calc( var( --space-x3 ) + var( --space ) );\n    height: 300px;\n}\n\n.teams-members__container__card {\n    width: 100%;\n    border-radius: 2px;\n    margin-bottom: var( --space );\n    display: flex;\n    align-items: center;\n    justify-content: space-between; \n    cursor: pointer; \n}\n\n.teams-members__container__card .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.teams-members__container__card__info{\n    margin-bottom: var(--space-quarter);\n    display: flex;\n    align-items: center;\n}\n\n.teams-members__container__card__info img {\n    width: calc( var( --space-x2 ) + var( --space-half ) );\n    height: calc( var( --space-x2 ) + var( --space-half ) );\n    border-radius: 50%; \n}\n\n.teams-members__container__card__info .icon-ball  {\n    font-size: var( --space-x2 );\n    color: var( --white-color );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.teams-members__container__card__info .icon-trophy {\n    font-size: calc( var( --space-x2 ) - var( --space-eighth ) );\n    color: var( --basic-gray-color );\n}\n\n.teams-members__container__card .icon-chevron-roght {\n    color: var(--basic-green-color);\n}\n\n.teams-members__container__card__headers{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: var(--new-background-color);\n    border-radius: 8px 8px 0 0;\n    padding: 11px 16px;\n    margin-bottom: 12px;\n}\n\n.teams-members__container__card__headers .baloa-table-column{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.teams-members__subtitle.baloa-username {\n    margin-top: var( --space-quarter );\n}\n\n.team-members__rute {\n    display: flex;\n    width: 392px;\n    height: var(--space-x2);\n    margin-top: var(--space-x2);\n    margin-left: var(--space-half);\n    border-radius: var(--space-half);\n    background: var(--white-color);\n}\n\n.team-members__rute__img {\n    color: var(--basic-green-color); \n    margin-left: var(--space-quarter);\n    padding: var(--space-quarter) var(--space) var(--space-quarter) var(--space-quarter); \n}\n\n.team-members__rute .icon-chevron-roght {\n    color: var(--basic-green-color);\n    margin: var(--space-quarter);\n}\n\n.team-members__rute__pague {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: calc(var(--space) - 4px);\n    line-height: var(--space);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.004em;\n}\n\n.team-members__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n}\n\n.team-members__team-photo {\n    margin-top: var( --space-half-quarter );\n}\n\n.team-members__team-photo .icon-ball {\n    font-size: calc( var( --space-x3 ) + var( --space-x2 ) + var( --space-quarter ) );\n    padding: var( --space-half );    \n    color: var(--white-color);\n    border-radius: 50%;\n    \n}\n\n.team-members__team-photo img{\n    width: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) );\n    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) );\n    border-radius: 50%;\n}\n\n.icon-x.team-members__icon-back{\n    color: var( --primary-dark-color );\n    font-size: var(--space);\n    cursor: pointer;\n    margin-bottom: var( --space-half );   \n}\n\n.league-team-members .new-tournament__center__content__tabs {\n    margin: 0;\n}\n\n.league-team-members {\n    background-color: var( --white-color );\n    border-radius: calc( var( --space ) - var( --space-eighth ) );\n}\n\n.team-members__header a {\n    justify-content: flex-end;\n    display: flex;\n    width: 100%;\n    margin: calc( var( --space ) + var( --space-quarter ) ) calc( var( --space ) + var( --space-eighth ) ) 0 0;\n}\n\n.team-members__header .baloa-headline-2 {\n    color: var( --primary-dark-color );\n    margin-top: var( --space );\n    margin-bottom: var( --space-half );\n}\n\n.team-members__header .baloa-normal-medium:first-of-type {\n    color: var( --basic-gray-color );    \n}\n\n.team-members__header .baloa-normal-medium:last-of-type {\n    color: var( --primary-dark-color );\n    margin: var( --space-half ) 0 var( --space-and-half ) 0;\n}\n\n.league-team-members__team-name {\n    margin-left: var( --space-half );\n}\n\n.league-team-members__tournament-team {\n    margin-left: var( --space );\n}\n\n.league-team-members__team-name .baloa-names,\n.league-team-members__tournament-team .baloa-names {\n    margin-bottom: var( --space-quarter );\n}\n\n.league-team-members__tournament-team .baloa-names,\n.league-team-members__tournament-team .baloa-username {\n    color: var( --primary-dark-color );\n}\n\n.league-team-members__team-name .baloa-names {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.league-team-members__btn-follow span {\n    font-size: calc( var( --space ) - var( --space-eighth ));\n}\n\n.league-team-members__btn-follow.following {\n    color: var( --white-color );\n    background: var( --new-green-color ) ;\n}\n\n.teams-members_tournamentList_card {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin: var(--space-x2);\n}\n\n.teams-members_tournamentList_card:hover{\n    background-color:rgba(177, 177, 177, 0.25);\n    cursor: pointer;\n    border-radius:4px;\n}\n\n.teams-members_tournamentList_card .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-x2 );\n    border-radius: 50%;\n    padding: var( --space-quarter );  \n}\n\n.teams-members_tournamentList_img{\n    width: var(--space-x2-and-half);\n    height: var(--space-x2-and-half);\n    float: left;\n    margin-top: var(--space-quarter);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half);\n    border-radius: 50%;\n}\n\n.teams-members_tournamentList_card .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-x2 );\n    border-radius: 50%;\n    padding: var( --space-quarter );  \n}\n\n.teams-members_tournamentList_card_inf{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.teams-members_tournamentList_card_text{\n    margin-left: var(--space-half);\n}\n\n.teams-members_tournamentList_card_text .baloa-names{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.teams-members_tournamentList_card_subText{\n    display: flex;\n    align-items: baseline;\n}\n\n.teams-members_tournamentList_card_subText.baloa-username p{\n    color: var(--primary-dark-color);\n    margin-right: var(--space);\n}\n\n.teams-members_tournamentList_card_tags div {\n    background: var( --primary-dark-color );\n    color: var( --white-color );\n    border-radius: var( --space-and-half );\n    padding: var( --space-quarter ) var( --space-half );\n}\n\n.teams-members_tournamentList_card_tags.baloa-username{\n    color: var( --primary-dark-color);\n    font-size: 11px;\n}\n\n.teams-members_tournamentList_card_tags  {\n    display: flex;\n}\n\n.teams-members_tournamentList_card_tags .tag-active{\n    background: var(--new-green-color);\n}\n\n.teams-members_tournamentList_card_tags div:first-of-type {\n    margin-right: var( --space-quarter );\n}\n\n.teams-members_tournamentList_card_tags div:last-of-type {\n    margin-left: var( --space-quarter );\n}\n\n.league-team-members__team-name .baloa-username{\n    color: var(--basic-gray-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .teams-members__container {\n        padding: 12px;\n    }\n\n    .teams-members_tournamentList_card{\n        margin: var(--space-half) 0;\n    }\n\n    .teams-members_tournamentList_card_inf {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .teams-members_tournamentList_card_text .baloa-names{\n        font-size: var(--space);\n    }\n\n    .teams-members_tournamentList_card_subText.baloa-username p{\n        font-size: var(--space);\n    }\n\n    .teams-members_tournamentList_card_tags.baloa-username {\n        margin: var(--space) 0;\n    }\n\n    .teams-members__container .scroll{\n        padding: 0;\n        height: 56vh; /*TODO: limite largo*/\n    }\n\n    .teams-members_tournamentList_card_tags div{\n        font-size: calc( var(--space) - var(--space-quarter) );\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
